module.exports = __webpack_public_path__ + "img/SPDbank.bb45ea67.png";